import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Header, VentasDetalle } from "../../components";
import { VentasMiListaClientesV2 } from "../../components/VentasMiListaClientesV2";
import CotizacionesGeneradas from "../CotizacionesGeneradas";
import MapaCalor from "../MapaCalor";
import ventasEjecutivoStyles from "../VentasEjecutivoV2/VentasEjecutivoV2.module.scss";
import styles from "./Ventas.module.scss";

const BASE = "/admin/ventas";

// Registro único de visualizaciones del hub. Para sumar una nueva (p. ej. habilitar Pizarra o
// Categorías) alcanza con completar su entrada acá: `path`/`Component` la vuelven navegable y la
// suman a las rutas; `disabled` la deja como marcador en gris. El grid 3×2 respeta este orden.
// `props` inyecta props extra al componente de la tab (CRM reusa los estilos de filtro de
// VentasEjecutivoV2 tal cual — 10.1); `wrapperClass` envuelve la tab en un contenedor propio.
const VENTAS_TABS = [
  { key: "detalle", label: "Detalle", path: "detalle", Component: VentasDetalle },
  {
    key: "crm",
    label: "CRM",
    path: "crm",
    Component: VentasMiListaClientesV2,
    props: { filterStyles: ventasEjecutivoStyles },
    wrapperClass: ventasEjecutivoStyles.containerVentasEjecutivo,
  },
  { key: "mapa-calor", label: "Mapa de Calor", path: "mapa-calor", Component: MapaCalor },
  { key: "cotizaciones", label: "Cotizaciones", path: "cotizaciones", Component: CotizacionesGeneradas },
  { key: "pizarra", label: "Pizarra", disabled: true },
  { key: "categorias", label: "Categorías", disabled: true },
];

const Ventas = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = VENTAS_TABS.find((t) => t.path && location.pathname === `${BASE}/${t.path}`)?.key;

  // Keep-alive: cada tab visitada se monta una vez y NO se desmonta al cambiar de tab (queda en el
  // DOM oculta con display:none y se vuelve a mostrar al volver). `visited` registra las tabs ya
  // montadas; una tab no visitada nunca se monta (no montamos las 4 de entrada). Como la instancia
  // persiste, sus queries no se re-disparan y sus filtros se conservan al volver.
  const [visited, setVisited] = useState(() => new Set());
  useEffect(() => {
    if (!activeKey) return;
    setVisited((prev) => (prev.has(activeKey) ? prev : new Set(prev).add(activeKey)));
  }, [activeKey]);

  // Ruta base /admin/ventas o subruta desconocida → al detalle (el hub la resuelve; appRoutes NO
  // lista /admin/ventas, ver regla 10.254). Va DESPUÉS de los hooks (nunca condicionar hooks).
  if (!activeKey) return <Navigate to={`${BASE}/detalle`} replace />;

  // Grid de visualizaciones que va en el leftContent del Header compartido. La tab activa lo pinta
  // en #2c3e50; las deshabilitadas quedan en gris, sin onClick (marcadores de lo que viene).
  const grid = (
    <div className={styles.vizGrid}>
      {VENTAS_TABS.map((tab) => {
        const isActive = tab.key === activeKey;
        const className = `${styles.vizCell} ${isActive ? styles.vizCellActive : ""} ${
          tab.disabled ? styles.vizCellDisabled : ""
        }`;
        return (
          <button
            key={tab.key}
            type="button"
            className={className}
            onClick={tab.disabled ? undefined : () => navigate(`${BASE}/${tab.path}`)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );

  // El shell arma el <Header leftContent={grid} expandChildren> y le pasa los filtros de la tab
  // activa como children; la tab los provee vía su prop renderHeader (mudanza de filtros, Fase 1).
  const renderHeader = (filtersContent) => (
    <Header leftContent={grid} expandChildren>
      {filtersContent}
    </Header>
  );

  // Keep-alive: se renderizan solo las tabs YA visitadas (o la activa en su primer render). Cada una
  // queda montada; la inactiva se oculta con display:none (.tabHidden) — no ocupa espacio ni captura
  // clicks/foco, y su <Header> (con sus filtros) también queda oculto, así el header solo muestra los
  // filtros de la tab activa. La instancia persiste ⇒ sin refetch ni pérdida de filtros al volver.
  return (
    <>
      {VENTAS_TABS.filter((tab) => tab.Component && (visited.has(tab.key) || tab.key === activeKey)).map(
        ({ key, Component, props, wrapperClass }) => {
          const el = <Component renderHeader={renderHeader} {...(props || {})} />;
          return (
            <div key={key} className={key === activeKey ? undefined : styles.tabHidden}>
              {wrapperClass ? <div className={wrapperClass}>{el}</div> : el}
            </div>
          );
        }
      )}
    </>
  );
};

export default Ventas;
